import { useCallback, useMemo } from "react";

import axios from "axios";

import { useBranding } from "../../hooks";

export const useHttpRequest = () => {
  const branding = useBranding();

  const axiosInstance = useMemo(() => {
    const instance = axios.create({
      baseURL: branding?.apiUrl || "",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    instance.interceptors.request.use((config) => {
      const token = localStorage.getItem("token");

      if (token) config.headers["Authorization"] = `Bearer ${token}`;

      return config;
    });

    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        console.log(error);
        return Promise.reject(error);
      },
    );

    return instance;
  }, [branding?.apiUrl]);

  const setAxiosInterceptors = useCallback(
    (token) => {
      if (token) axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    [axiosInstance],
  );

  const clearAxiosInterceptors = useCallback(() => {
    delete axiosInstance.defaults.headers.common["Authorization"];
  }, [axiosInstance]);

  return { axiosInstance, setAxiosInterceptors, clearAxiosInterceptors };
};

export const useRootHttpRequest = () => {
  const branding = useBranding();

  const axiosInstance = useMemo(
    () =>
      axios.create({
        baseURL: branding?.apiUrl.split("fit-sync")[0] || "", // get root url without /fit-sync/v1
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
    [branding?.apiUrl],
  );

  return { axiosInstance };
};

export {
  getClasses,
  getClassByID,
  getTrainerByID,
  getClassBookings,
  getclassTypeTranslations,
  bookClass,
} from "./classes";
export {
  getFirstTimePackages,
  getRenewalPackages,
  getPtPackages,
  getMemberProducts,
  getproductTranslations,
  getpaymentPlanTranslations,
  getContractPayments,
} from "./packages";
export {
  getMemberProfile,
  getMemberEndedContracts,
  updateMemberProfile,
  changeAccountPassword,
  getTransactionHistory,
  cancelSubscription,
  getStates,
  getCities,
  getContractCharges,
  getMemberProfilePhoto,
  updateProfilePhoto,
  registerCard,
} from "./userProfile";
export { getApiOptions } from "./options";
